export default {
  general: {
    UNDEFINED: -1
  },
  time: {
    MINUTES_TO_SECONDS: 60,
    ONE_MINUTE_IN_DAYS: 0.0006944,
    HOURS_TO_DAYS: 86400
  },
  order: {
    type: {
      PENDING: 'pending',
      COMING: 'coming',
      READY: 'ready'
    },
    status: {
      DRAFT: 'DRAFT',
      PENDING: 'PENDING',
      ACCEPTED: 'ACCEPTED',
      SUPPLIED: 'SUPPLIED',
      ORDERWAITING: 'ORDERWAITING',
      TRANSIT: 'TRANSIT',
      ONSITE: 'ONSITE',
      COMPLETED: 'COMPLETED',
      COMPLETED_REQUEST: 'COMPLETED_REQUEST',
      CANCELED: 'CANCELED',
      CANCEL_REQUEST: 'CANCEL_REQUEST',
      SCHEDULE: 'SCHEDULE'
    }
  },
  animation: {
    road: {
      LEFT: 'l',
      RIGHT: 'r'
    },
    state: {
      PAUSED: 'paused',
      RUNNING: 'running'
    },
    speed: {
      SLOW: 3,
      NORMAL: 2,
      FAST: 1,
      limit: {
        NORMAL: 30,
        FAST: 70
      }
    }
  },
  map: {
    type: {
      ROUTE: 'route',
      NAVIGATION: 'navigation'
    },
    marker: {
      BRANCH: 'branch',
      DELIVERY: 'delivery',
      DRIVER: 'driver'
    },
    icon: {
      branch: '/img/ic_marker_branch.png',
      delivery: '/img/svg/ic_marker_delivery.svg',
      driver: '/img/ic_marker_driver.png'
    }
  },
  chat: {
    ACCEPTED_FILES: 'image/*',
    MESSAGES_LIMIT: 100,
    NOTIFICATION_TYPE: 'default',
    type: {
      FILE: 'file',
      AUDIO: 'audio'
    },
    theme: {
      DARK: 'dark',
      LIGHT: 'light'
    }
  },
  AVATAR: {
    DRIVER: `${process.env.VUE_APP_S3}/avatar-driver.png`,
    SUPPORT: `${process.env.VUE_APP_S3}/avatar-soporte.png`,
    CLIENT: `${process.env.VUE_APP_S3}/avatar-cliente.png`
  },
  TASK_TYPE: {
    FASTFOOD: 'fastfood',
    PHARMACY: 'pharmacy',
    PARCEL: 'parcel',
    MARKET: 'market',
    INTERNET: 'internet',
    LABS: 'labs',
    TELCO: 'telco',
    FOOD: 'food',
    MEAT: 'meat'
  },
  URL: {
    JELP_DELIVERY: 'https://jelp.delivery/'
  },
  CASH: 'cash'
}
